import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog } from '../../types'
import { CmsConverterService, defaultFSCatalog } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowRelatedContentConverter extends CmsConverterService<PanelRowRelatedContentData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    return {
      links: formData.st_related_content ?? defaultFSCatalog
    }
  }
}

export const PANEL_ROW_RELATED_CONTENT_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowRelatedContentData>>('PanelRowRelatedContentConverter')

export interface PanelRowRelatedContentData extends ConvertedComponentData {
  links: FsCatalog;
}
